import React from 'react';

const Blog = () => {
    return (
        <div className='' id='blog'>
            <h1 className='text-5xl mt-80 px-20'>Blogs about different web technologies are comming soon</h1>
        </div>
    );
};

export default Blog;